<template>
  <section class="px-lg-0 company">
    <nav
      v-for="(item, index) in menuCompany"
      :key="index"
      class="mt-4 mt-lg-2 ms-3 ms-lg-0 breadcrumb-support"
    >
      <div
        v-if="item.path === $route.fullPath"
        class="text-decoration-none text-start d-block fs-7"
      >
        <a href="/" class="text-decoration-none text-secondary"> Inicio </a>
        > <span class="text-dark fw-semibold">{{ item.breadcrumb }}</span>
      </div>
    </nav>
    <nav ref="menuContainer" class="container d-flex mt-4 overflow-x-auto">
      <router-link
        v-for="(item, index) in menuCompany"
        :key="index"
        :to="item.path"
        class="col-5 col-md pointer text-decoration-none"
        @click="scrollToCenter(index)"
      >
        <div
          class="item px-3 px-lg-0"
          :class="item.path === $route.fullPath ? 'active' : 'no-active'"
        >
          <i :class="item.icon" class="icon ps-2" />
          <p class="m-0 text-center ms-1">{{ item.title }}</p>
        </div>
      </router-link>
    </nav>
    <div class="container-fluid p-3">
      <NuxtPage />
    </div>
  </section>
</template>

<script lang="ts">
import { store } from "~/store";
import type { MenuCompany } from "~/interfaces/MenuCompany";
import smoothScroll from "@/utils/smooth-scroll";

export default {
  mixins: [smoothScroll],

  data: function () {
    return {
      menuCompany: [] as MenuCompany[],
    };
  },

  created() {
    store.commit("setCanCloseMenu", true);
  },

  mounted() {
    this.menuCompany = [
      {
        icon: "bi bi-person-bounding-box",
        title: "Aviso de privacidad",
        path: "/privacidad",
        breadcrumb: "Aviso de privacidad",
      },
      {
        icon: "bi bi-hammer",
        title: "Aviso legal",
        path: "/aviso-legal",
        breadcrumb: "Aviso legal",
      },
      {
        icon: "bi bi-file-text",
        title: "Términos y condiciones",
        path: "/terminos-y-condiciones",
        breadcrumb: "Términos y condiciones",
      },
      {
        icon: "bi bi-box",
        title: "Garantías y devoluciones",
        path: "/garantias-y-devoluciones",
        breadcrumb: "Garantías y devoluciones",
      },
      {
        icon: "bi bi-arrow-counterclockwise",
        title: "Políticas de monedero, devolución y cancelación",
        path: "/politicas-de-devolucion",
        breadcrumb: "Políticas de monedero, devolución y cancelación",
      },
    ];
  },
  methods: {
    scrollToCenter(index: number) {
      const container = this.$refs.menuContainer as HTMLBaseElement;
      const item = container.children[index];
      const itemRect = item?.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      if (itemRect) {
        const offset =
          itemRect.left -
          containerRect.left +
          itemRect.width / 2 -
          containerRect.width / 2;

        this.smoothScroll(
          container,
          container.scrollLeft,
          container.scrollLeft + offset,
          500,
        );
      }
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/company";
</style>
